module.exports = __webpack_public_path__ + "static/media/logo.146f196f.svg";